import { createReducer, on } from '@ngrx/store';
import {
  CreateRecipePM,
  DescriptionChanged,
  EndDateChanged,
  EndDateCleared,
  InactiveChanged,
  NameChanged,
  PointExpirationTypeChanged,
  PointExpirationValueChanged,
  PointMultiplierChanged,
  PointSourcesSuccess,
  RemarkChanged,
  RoundingModeChanged,
  SchemaChanged,
  StartDateChanged,
  StartDateCleared,
  SubmitDataPM,
  UpdateRecipePM,
} from '../actions/points-multiplier.actions';
import { CloseSideNav, EditRecipe } from '../actions/search.actions';
import { PointsMultiplierCreateUpdateState } from '../models/points-multiplier.model';

import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';

const initialState: PointsMultiplierCreateUpdateState = {
  isUpdate: false,
  recipeType: 'REWARD_MULTIPLIER_POINTS',
  recipeImagePath: 'assets/images/recipes/points_multiplier.png',
  recipeDisplayName: '',
  selectedSchema: '',
  pointSources: [],
  selectedPointSourceId: 0,
  selectedPointSourceName: 'Transaction',
  pointExpirationType: 'DAYS',
  pointExpirationValue: null,
  selectedPointMultiplier: null,
  selectedRemark: '',
  startDate: '',
  endDate: '',
  inactive: false,
  roundingModes: ['UP', 'DOWN', 'HALF_UP'],
  roundingMode: 'HALF_UP',
  description: '',
  submit: false,
};

export const PointsMultiplierCreateUpdateReducer = createReducer(
  initialState,
  on(EditRecipe, (state, { row }) => {
    if (row.recipeType === state.recipeType) {
      return {
        ...state,
        isUpdate: true,
        recipeDisplayName: row.recipeDisplayName || null,
        selectedSchema: row.loyaltySchemaCode || null,
        selectedPointMultiplier: row.pointsMultiplier || null,
        selectedPointSourceId: row.loyaltyPointSourceId,
        pointExpirationType: row.pointExpirationType,
        pointExpirationValue: row.pointExpirationValue,
        selectedRemark: row.remark,
        roundingMode: row.roundingMode,
        startDate: row.startDate || '',
        endDate: row.endDate || '',
        inactive: row.deleteFlag ? true : false,
        description: row.description,
      };
    }
    return state;
  }),
  on(NameChanged, (state, { recipeDisplayName }) => ({
    ...state,
    recipeDisplayName,
  })),
  on(SchemaChanged, (state, { selectedSchema }) => ({
    ...state,
    selectedSchema,
  })),
  on(PointSourcesSuccess, (state, { pointSources }) => {
    const registrationSource = pointSources.find(
      (source) =>
        source.loyaltyPointSourceDescription === 'system.tableloyaltypointsource.transaction',
    );
    const defaultId = registrationSource ? registrationSource.loyaltyPointSourceId : 0;

    return {
      ...state,
      pointSources: pointSources,
      selectedPointSourceId: defaultId,
    };
  }),
  on(PointMultiplierChanged, (state, { selectedPointMultiplier }) => ({
    ...state,
    selectedPointMultiplier,
  })),
  on(RoundingModeChanged, (state, { roundingMode }) => ({
    ...state,
    roundingMode,
  })),
  on(RemarkChanged, (state, { selectedRemark }) => ({
    ...state,
    selectedRemark,
  })),
  on(PointExpirationTypeChanged, (state, { pointExpirationType }) => ({
    ...state,
    pointExpirationType,
  })),
  on(PointExpirationValueChanged, (state, { pointExpirationValue }) => ({
    ...state,
    pointExpirationValue,
  })),
  on(StartDateChanged, (state, { startDate }) => ({
    ...state,
    startDate,
  })),
  on(StartDateCleared, (state) => ({
    ...state,
    startDate: '',
  })),
  on(EndDateChanged, (state, { endDate }) => ({
    ...state,
    endDate,
  })),
  on(EndDateCleared, (state) => ({
    ...state,
    endDate: '',
  })),
  on(InactiveChanged, (state, { inactive }) => ({
    ...state,
    inactive,
  })),
  on(DescriptionChanged, (state, { description }) => ({
    ...state,
    description,
  })),
  on(CreateRecipePM, UpdateRecipePM, (state) => ({
    ...state,
    submit: true,
  })),
  on(ActiveComponentChanged, CloseSideNav, () => initialState),
  on(SubmitDataPM, (state) => ({
    ...state,
    submit: true,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
